<template>
  <div>
        <h1 class="has-no-margin-bottom">{{$t('experiences.header_main')}}</h1>
        <!-- review form -->
        <experience-from @update="initExperiences(true)" />
        <div class="hr--dotted"></div>
        <!-- old reviews -->
        <h2>{{$t('experiences.history.header_sub')}}</h2>
        <p>{{$t('experiences.history.info')}}</p>
        <!-- loop through experiences and add them -->
        <loader :loading="fetch.loading" :error="fetch.error">
            <div v-if="experiecesCount > 0">
                <div v-for="(experience, index) in experiences.slice(0, amountToShow)" class="col-12" :key="index">
                    <div class="row experience" :class="{'odd': index % 2 === 0, 'even': index % 2 !== 0 }">
                        <div class="col-md-10 col-sm-12">
                            <div class="row">
                                <div class="col-8">
                                    <div class="row">
                                        <p><strong>{{experience.title}}</strong> </p>
                                    </div>
                                    <div class="row">
                                        <star-rating  v-if="index % 2 === 0" v-bind:star-size="15" active-color="#5a5a5a"
                                                      v-bind:show-rating = "false" v-bind:rating = "experience.rating/2"
                                                      v-bind:read-only = "true" v-bind:increment = "0.5"
                                                      inactive-color="#dedede" border-color="#5a5a5a"
                                                      v-bind:border-width="2">
                                        </star-rating>
                                        <star-rating  v-else v-bind:star-size="15" active-color="#5a5a5a"
                                                      v-bind:show-rating = "false" v-bind:rating = "experience.rating/2"
                                                      v-bind:read-only = "true" v-bind:increment = "0.5"
                                                      inactive-color="#ffffff" border-color="#5a5a5a"
                                                      v-bind:border-width="2">
                                        </star-rating>
                                    </div>
                                </div>
                                <div class="col-4 align-right">
                                    <p>{{formatDate(experience.created)}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <p>{{experience.text}}</p>
                            </div>

                        </div>
                        <div class="col-md-2  col-sm-12 align-center">
                            <p class="status">{{$t('experiences.history.status')}}</p>
                            <p  :class=experience.status>
                                {{$t('experiences.status.' + experience.status)}}
                            </p>
                        </div>
                        <p v-if="moreAvailable && index === amountToShow - 1"
                           class="read-more status"
                           v-on:click="incrementAmount">
                            {{$t('experiences.view_more')}}
                        </p>
                    </div>
                </div>
            </div>
            <div v-else>
                <p>{{$t('experiences.no_reviews')}}</p>
            </div>
        </loader>
  </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import ExperienceFrom from '../components/forms/ExperienceForm';
    import StarRating from 'vue-star-rating';
    import {
        FETCH_EXPERIENCES,
        GET_EXPERIENCES,
        GET_EXPERIENCES_COUNT,
    } from '../store/modules/experiences';
    import moment from 'moment';
    import Loader from '../components/general/Loader';

    @Component({
        components: {Loader, ExperienceFrom, StarRating}
    })
    export default class Experiences extends Vue {
        fetch = {loading: false, error: false};
        amountToShow = null;
        startingValue  = 3;
        incrementValue = 3;
        moreAvailable = false;

        created() {
            this.fetch.loading = true;
            this.fetch.error = false;
            this.initExperiences();
        }

        async initExperiences(firstTime = true){
            this.fetch.loading = true;
            try {
                await this.$store.dispatch(FETCH_EXPERIENCES);
            } catch (e){
                this.fetch.error = this.$t('common.notify_fetch_failure');
            } finally {
                this.fetch.loading = false;
            }
            if (firstTime){
                this.initAmount();
            }
        }

        get experiences() {
            return this.$store.getters[GET_EXPERIENCES];
        }

        get experiecesCount(){
            return this.$store.getters[GET_EXPERIENCES_COUNT];
        }

        initAmount(){
            if (this.experiecesCount <= this.startingValue){
                this.amountToShow = this.experiecesCount;
                this.moreAvailable = false;
            } else {
                this.amountToShow = this.startingValue;
                this.moreAvailable = true;
            }
        }

        incrementAmount(){
            var oldAmount = this.amountToShow;
            var newAmount = null;
            if (this.experiecesCount <= oldAmount+this.incrementValue){
                newAmount = this.experiecesCount;
                this.moreAvailable = false;
            } else {
                newAmount = oldAmount + this.incrementValue;
                this.moreAvailable = true;
            }
            this.amountToShow = newAmount;
        }

        formatDate(date) {
            return moment(date, 'DD-MM-YYYY h:mm').calendar();
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Experiences.vue